function resolveDeployEngineOptions({
  isBetaEngineV3Eligible,
  isBetaEngineV3Enabled,
  legacyEngineSelectorEnabled,
  formIsPipelineEngine
}) {
  if (legacyEngineSelectorEnabled && !formIsPipelineEngine) return 'GA';
  if (isBetaEngineV3Eligible && isBetaEngineV3Enabled) return 'v3';
  return 'Beta';
}

export default resolveDeployEngineOptions;
